import { BaseModel } from "model/BaseModel";

export default class ItemInspecaoFrota implements BaseModel {

    id: number | null;
    codigo: string | null;
    nome: string;
    intervaloHorasRevisao: number | null;
	intervaloQuilometragemRevisao: number | null;
    periodicidade: string;
	vlPeriodicidadeRevisao: number | null;

    constructor(
        id: number | null = null,
        codigo = null,
        nome = '',
        vlPeriodicidadeRevisao = 0,
        intervaloHorasRevisao = 0,
        intervaloQuilometragemRevisao = 0,
        periodicidade = 'DIAS'

    ) {
        this.id = id;
        this.codigo = codigo;
        this.nome = nome;
        this.periodicidade = periodicidade;
        this.vlPeriodicidadeRevisao = vlPeriodicidadeRevisao;
        this.intervaloHorasRevisao = intervaloHorasRevisao;
        this.intervaloQuilometragemRevisao = intervaloQuilometragemRevisao;
    }

}